import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import api from "../api";

const tenantGuid = process.env.REACT_APP_TENAT_ID;

const getAllProducts = async () => {
  const apiGetProducts = ApiConstant.getHomeProducts + tenantGuid;
  return await api
    .get(apiGetProducts)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};

const getAllProducts1 = async () => {
  const apiGetProducts = ApiConstant.getHomeProducts1 + tenantGuid;
  return await api
    .get(apiGetProducts)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};

const getCategory = async () => {
  return await api
    .get(ApiConstant.getCategory)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};

const getSubCategory = async () => {
  return await api
  .get(ApiConstant.getSubCategory).then(function (response: any){
    if(response){
      return response.data;
    } else{
      return null;
    }
  }).catch(function (error: any){
    console.error("error reading get all sub categories data.", error)
  })
}

const getAllAdminProducts = async () => {
  const apiGetProducts = ApiConstant.getAllAdminProducts /* + tenantGuid */;
  return await api
    .get(apiGetProducts)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};

export type ProductPOSQuantitytDTO = {
  posId: number;
  productName: string;
  quantity: number;
  value: number;
  posAlias: string;
};

const getProductPOSQuantity = async (
  productId: number
): Promise<ProductPOSQuantitytDTO[] | null> => {

  const apiGetProductQty = `${ApiConstant.getProductPOSQuantity}/${productId}`;

  return await api
    .get(apiGetProductQty)
    .then(function (response: any) {
      if (response) {
        return response.data as ProductPOSQuantitytDTO[];
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading product POS inventory data.", error);
      return null;
    });
};


const saveNewProduct = async (product: any) => {
  return await api
  .post(ApiConstant.saveProduct, product, {
    headers: {
      "content-type": "application/json",
    },
  })
  .then(function (response: any) {
    if (response) {
      return response.data;
    }
  })
  .catch(function (error) {
    Helpers.ConsoleLog(error, "error");
    return error;
  });
}

const saveProduct = async (product: any) => {
  return await api
  .put(ApiConstant.saveProduct, product, {
    headers: {
      "content-type": "application/json",
    },
  })
  .then(function (response: any) {
    if (response) {
      return response.data;
    }
  })
  .catch(function (error) {
    Helpers.ConsoleLog(error, "error");
    return error;
  });
}

const updateProduct = async (product: any) => {
  // console.warn("Api Request", product);
  return await api
  .put(ApiConstant.updateProduct, product, {
    headers: {
      "content-type": "application/json",
    },
  })
  .then(function (response: any) {
    if (response) {
      return response.data;
    }
  })
  .catch(function (error) {
    Helpers.ConsoleLog(error, "error");
    return error;
  });
}

const deleteProduct = async (productId: number) => {
  try {
      const productDelete: any = await api
      .delete(ApiConstant.deleteProduct+`?productID=${productId}`)
      .then((res: any)=> {
          if(res)            
              return res.data;
          else
              return null;         
      })
      .catch(function (error: any) {
          console.error('error deleting user.', error);
      });
      const response = productDelete != null ? productId : null;        
      return response;
  }
  catch
  {
      console.log('error in delete user detail');
      return false;
  }
}

const getReorderProductsByOrderId = async (orderId: number) => {
  try {
    const apiUrl = ApiConstant.getReorderProductsByOrderId.replace("{0}", String(orderId));
    const response = await api.get(apiUrl);

    if (response && response.data) {
      return response.data;
    } else {
      console.warn("No data returned for reorder products");
      return null;
    }
  } catch (error) {
    console.error("Error fetching reorder products:", error);
    return null;
  }
};

 export const getProductWisePosOpenOrderQty = async (productId: number) => {
    try {
        const result: any = await api
            .get(`${ApiConstant.getproductwisePosOpenorderqty}/${productId}`)
            .then((response: any) => {
                if (response)
                    return response.data;
                else
                    return null;
            })
            .catch((error: any) => {
                console.error("Error reading POS open order qty.", error);
                return null;
            });

        const responseData = result != null ? result : null;
        return responseData;
    }
    catch (e) {
        console.log("Error in getProductWisePosOpenOrderQty");
        return [];
    }
};

const ProductService = {
  getAllProducts,
  getCategory,
  getSubCategory,
  getAllAdminProducts,
  getProductPOSQuantity,
  saveNewProduct,
  saveProduct,
  updateProduct,
  deleteProduct,
  getReorderProductsByOrderId,
  getAllProducts1,
  getProductWisePosOpenOrderQty
  
};

export default ProductService;
